/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import visionImg from "assets/images/mission_vision.png";

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container id="profile-container">
        <Grid container spacing={3} alignItems="center" sx={{ marginBottom: "20px" }}>
          <Grid item xs={12} lg={6}>
            <h1 className="main-head">our vision</h1>
            <p className="text-j pt-3 text-j">
              To build and sustain a unique Law Institute of International standards, capable of
              churning out a new breed of Lawyers and Scholars in Law kindled with fire and endowed
              with skill of Layering to serve the nation.
            </p>
            <img src={visionImg} alt="SNLC Vision" className="img-fluid" />
          </Grid>
          <Grid item xs={12} lg={6}>
            <h1 className="main-head">our mission</h1>
            <p className="py-1 text-j">
              To mould a new breed of globally competent and socially committed lawyers, capable of
              operating legal matters effectively, by imparting value based Education.
            </p>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
